import { render } from "./ContactWindow.vue?vue&type=template&id=50c9a44e&scoped=true"
import script from "./ContactWindow.vue?vue&type=script&lang=js"
export * from "./ContactWindow.vue?vue&type=script&lang=js"

import "./ContactWindow.vue?vue&type=style&index=0&id=50c9a44e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c9a44e"]])

export default __exports__